/* eslint-disable react/prop-types */
import { CheckCircle } from "@mui/icons-material";
import { RiDeleteBinLine } from "react-icons/ri";
import childIllustration from "../../assets/child-illustration.webp";
import { CircularProgress } from "@mui/material";
export const CharacterTile = ({
  character,
  handleActionClick,
  deleteKid,
  isSelected,
  onClick,
}) => {
  return (
    <div
      className={`flex group transition-all duration-200 ease-in-out flex-col gap-3 justify-center items-center ${
        isSelected ? "bg-[#3CC3AA26]" : ""
      } hover:bg-[#3CC3AA26] md:p-6 p-4 rounded-[20%]`}
    >
      <div className="relative group-hover:scale-110 ">
        <div
          onClick={onClick}
          className=" w-[8rem] h-[8rem] md:w-[12rem] md:h-[12rem] overflow-hidden rounded-full drop-shadow-lg bg-slate-50"
        >
          {character?.is_generation_pending ? (
            <div className="flex justify-center items-center h-full w-full">
              <CircularProgress />
            </div>
          ) : character?.avatar_url ? (
            <img
              className="w-full h-full object-cover"
              src={character?.avatar_url}
              alt={character.name}
            />
          ) : (
            <img src={childIllustration} alt="child illustration" />
          )}
        </div>
        <div
          className={`${
            isSelected ? "flex" : "hidden"
          } absolute top-1 right-1 md:top-4 md:right-3 bg-white h-[24px] w-[24px]  items-center justify-center rounded-full`}
        >
          <CheckCircle color="primary" />
        </div>
      </div>
      <h1 className="text-xl font-medium">{character.name}</h1>
      <div className="flex gap-2">
        <button
          className="md:px-10 px-6 py-2 rounded-full text-[#3CC3AA] hover:bg-[#ffff] font-bold text-lg border-2 border-solid border-[#3CC3AA]"
          onClick={() => handleActionClick(character)}
        >
          Edit
        </button>
        <RiDeleteBinLine
          className=" delete-icon cursor-pointer z-30"
          onClick={() => deleteKid(character.id)}
        />
      </div>
    </div>
  );
};
